<template>
  <div class="modal-overlay">
    <div
      ref="kt_modal_tabela_ibpt_atualizar"
      data-bs-backdrop="static"
      class="modal fade"
      data-bs-keyboard="false"
      v-modal-drag
      tabindex="-1"
      id="kt_modal_tabela_ibpt_atualizar"
    >
      <div
        class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title">Atualizar Tabela IBPT</h3>
            <div
              class="btn btn-icon btn-sm btn-active-light-primary"
              data-bs-dismiss="modal"
              @click="this.$emit('exibirModalTabelaIbptAtualizar', false)"
            >
              <span class="svg-icon svg-icon-2x">
                <img src="media/icons/duotune/arrows/arr061.svg" />
              </span>
            </div>
          </div>
          <div class="modal-body p-8">
            <div class="row">
              <div
                class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-2"
              >
                <div
                  class="fv-row text-center bg-light-secondary rounded border-secondary border-2 border-dashed p-3"
                >
                  <el-upload
                    :id="`uploadRef`"
                    action="#"
                    :on-exceed="handleLimitExceed"
                    :before-remove="handleRemove"
                    v-model:file-list="this.tabelaIbptViewModel"
                    :auto-upload="false"
                    multiple
                    drag
                    :limit="27"
                    :disabled="disableUpload"
                  >
                    <el-icon class="el-icon--upload"><upload-filled /></el-icon>
                    <div class="el-upload__text">
                      Solte os arquivos aqui ou
                      <em>clique para fazer o upload</em>
                    </div>
                  </el-upload>
                  <div class="mt-6">
                    Envie os arquivos .csv da Tabela Ibpt para atualização.
                    <br />Permitido até
                    <b class="text-primary">27 arquivos</b> por atualização.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer d-flex justify-content-end">
            <button
              class="btn btn-danger svg-icon-white me-2 mb-2"
              data-bs-dismiss="modal"
              @click="this.$emit('exibirModalTabelaIbptAtualizar', false)"
            >
              <span class="svg-icon svg-icon-1">
                <inline-svg
                  src="media/icons/duotune/arrows/arr015.svg"
                  class="me-2"
                />Cancelar
              </span>
            </button>
            <button
              class="btn btn-success svg-icon-white mb-2"
              @click="atualizarTabelaIbpt()"
              v-bind:data-kt-indicator="this.loading ? 'on' : 'off'"
            >
              <span class="indicator-progress">
                <span
                  class="spinner-border spinner-border-sm align-middle ms-1"
                ></span>
                Aguarde...
              </span>
              <span class="svg-icon svg-icon-1" v-if="!this.loading">
                <inline-svg
                  src="media/icons/duotune/arrows/arr016.svg"
                  class="me-2"
                />Confirmar
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <LoadingModal
    :nomeRef="'loadingModalTabelaIbptAtualizar'"
    mensagem=""
    v-if="this.loading === true"
  ></LoadingModal>
</template>

<script>
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { UploadFilled } from "@element-plus/icons-vue";
import LoadingModal from "@/components/modals/general/LoadingModal.vue";
import {
  hideModal,
  hideModalId,
  getOrCreateInstanceModal,
} from "@/core/helpers/dom";

export default {
  emits: ["exibirModalTabelaIbptAtualizar"],
  components: {
    LoadingModal,
    UploadFilled,
  },
  methods: {
    async atualizarTabelaIbpt() {
      await this.exibirModalLoading(true);
      var tabelas = {
        tabelaIbptViewModel: [],
      };
      for (var item of this.tabelaIbptViewModel) {
        if (item.status === "ready") {
          item.formFile = item.raw;
          tabelas.tabelaIbptViewModel.push(item);
        }
      }

      var formData = this.$utils.convertModelToFormData(tabelas);
      try {
        var ret = await this.$store.dispatch(
          "ibpt/atualizarTabelaIbpt",
          formData
        );
        if (ret.Success === true) {
          await this.exibirModalLoading(false);
          await this.showSuccessAlert(ret.Message);
          this.$emit("exibirModalTabelaIbptAtualizar", false);
          hideModalId("kt_modal_tabela_ibpt_atualizar");
        } else {
          await this.exibirModalLoading(false);
          await this.showErrorAlert(ret.Message);
        }
      } catch (error) {
        await this.exibirModalLoading(false);
        await this.showErrorAlert(error);
      }
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async exibirModalLoading(exibir) {
      if (exibir === true) {
        this.loading = true;
        await this.sleep(100);
        getOrCreateInstanceModal("loadingModalTabelaIbptAtualizar");
      } else {
        await this.sleep(500);
        hideModalId("loadingModalTabelaIbptAtualizar");
        await this.sleep(100);
        this.loading = false;
      }
    },
    async handleLimitExceed() {
      this.disableUpload = true;
      await this.showInvalidAlert(
        "Excedido o limite máximo de arquivos permitidos por atualização!"
      );
      this.disableUpload = false;
    },
    async handleRemove() {
      this.disableUpload = true;
      let alert = await this.showQuestionAlert("Deseja remover o arquivo?");
      this.disableUpload = false;
      if (alert.isConfirmed) {
        return true;
      } else {
        return false;
      }
    },
    async showSuccessAlert(text) {
      await Swal.fire({
        text: text,
        icon: "success",
        buttonsStyling: false,
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "btn fw-bold btn-success",
        },
        didOpen: () => {
          if (this.timeOut) {
            clearTimeout(this.timeOut);
            this.timeOut = null;
          }

          const confirmButton = document.querySelector(".swal2-confirm");
          if (confirmButton) {
            confirmButton.focus();
          }

          document.addEventListener("keydown", this.handleEnterKey);
        },
        willClose: () => {
          document.removeEventListener("keydown", this.handleEnterKey);
        },
      });
    },
    async showInvalidAlert(text) {
      await Swal.fire({
        text: text,
        icon: "warning",
        buttonsStyling: false,
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "btn fw-bold btn-warning",
        },
        didOpen: () => {
          if (this.timeOut) {
            clearTimeout(this.timeOut);
            this.timeOut = null;
          }

          const confirmButton = document.querySelector(".swal2-confirm");
          if (confirmButton) {
            confirmButton.focus();
          }

          document.addEventListener("keydown", this.handleEnterKey);
        },
        willClose: () => {
          document.removeEventListener("keydown", this.handleEnterKey);
        },
      });
    },
    async showQuestionAlert(text) {
      return await Swal.fire({
        text: text,
        icon: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "ENTER - Sim",
        cancelButtonText: "ESC - Não",
        customClass: {
          confirmButton: "btn fw-bold btn-primary",
          cancelButton: "btn fw-bold btn-danger",
        },
        didOpen: () => {
          if (this.timeOut) {
            clearTimeout(this.timeOut);
            this.timeOut = null;
          }

          const confirmButton = document.querySelector(".swal2-confirm");
          if (confirmButton) {
            confirmButton.focus();
          }

          document.addEventListener("keydown", this.handleEnterKey);
        },
        willClose: () => {
          document.removeEventListener("keydown", this.handleEnterKey);
        },
      });
    },
    async showErrorAlert(text) {
      await Swal.fire({
        text: text,
        icon: "error",
        buttonsStyling: false,
        confirmButtonText: "OK",
        customClass: {
          confirmButton: "btn fw-bold btn-danger",
        },
        didOpen: () => {
          if (this.timeOut) {
            clearTimeout(this.timeOut);
            this.timeOut = null;
          }

          const confirmButton = document.querySelector(".swal2-confirm");
          if (confirmButton) {
            confirmButton.focus();
          }

          document.addEventListener("keydown", this.handleEnterKey);
        },
        willClose: () => {
          document.removeEventListener("keydown", this.handleEnterKey);
        },
      });
    },
    handleEnterKey(event) {
      if (event.key === "Enter") {
        const confirmButton = document.querySelector(".swal2-confirm");
        if (confirmButton) {
          confirmButton.click();
        }
      } else if (event.key === "Escape") {
        const cancelButton = document.querySelector(".swal2-cancel");
        if (cancelButton) {
          cancelButton.click();
        }
      }
    },
  },
  data() {
    return {
      timeOut: null,
      disableUpload: false,
      tabelaIbptViewModel: [],
      loading: false,
    };
  },
};
</script>

<style></style>
